import { useTranslation } from 'react-i18next';

import { DatePickerField } from 'fields';
import { useField } from 'formik';
import dayjs from 'dayjs';

export default function DeliveryStartDate() {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'CustomerDetails' });

  const [{ value: transportMethod }] = useField('transportMethod');

  return (
    <DatePickerField
      required
      disablePast
      name="startDate"
      label={t(`labels.date${transportMethod}`)}
      minDate={dayjs().add(1, 'day')}
    />
  );
}
